import { I12VOLINSTCHAUF_State } from '@batical/types/src'

const I12VOLINSTCHAUF: I12VOLINSTCHAUF_State = {
  bati_version: 1,
  deleted: 0,
  name: '',
  saveDate: 0,
  ch_puissanceAcier: 0,
  ch_puissanceFonte: 0,
  rad_panneau: 0,
  rad_fonte: 0,
  rad_alu: 0,
  rad_conv: 0,
  cond_bi: 0,
  cond_mono: 0,
  in_dn: 0.0,
  in_longeur: 0.0,
  result: 0.0,
  mode: 'none',
  calcul_code: 'I12VOLINSTCHAUF'
}

export default I12VOLINSTCHAUF
